export enum FollowUpKind {
    FOLLOW_UP = "follow_up",
    SELF_EVALUATION = "self_evaluation",
}
